import { withInstall } from '@element-plus/utils'

import MultipleInput from './src/multiple-input.vue'

export const ElMultipleInput = withInstall(MultipleInput)
export default ElMultipleInput

export * from './src/multiple-input'
